export default {
  path: '/',
  name: 'home',
  component: () => import('@/pages/home/Home.vue' /* webpackChunkName: 'home' */),
};
